// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"correspondenceListItemSkeleton_skeleton__3jqmG","info":"correspondenceListItemSkeleton_info__3tA2j"};